<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
  <div class="kt-portlet kt-portlet--mobile">
      <div class="kt-portlet__body">
        <div class="kt-form kt-form--label-right">
            <div class="row align-items-center">
                <div class="col-xl-12 order-2 order-xl-1 pr-0">
                    <form class="row align-items-center" [formGroup]="form">
                        <div class="col-12 row mb-2 pr-0">
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Campaign Code:</label>
                            </div>
                            <div class="col-md-2 kt-form__control">
                                <input type="text" formControlName="campaign_code" placeholder="Search" class="form-control">
                            </div>
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Username:</label>
                            </div>
                            <div class="col-md-2 kt-form__control">
                                <input type="text" formControlName="username" placeholder="Search" class="form-control">
                            </div>
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Phone Number:</label>
                            </div>
                            <div class="col-md-2 kt-form__control">
                                <input type="text" formControlName="mobile" placeholder="Search" class="form-control">
                            </div>
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Source:</label>
                            </div>
                            <div class="col-md-2 kt-form__control">
                                <select class="col-8 form-control" formControlName="source">
                                    <option *ngFor="let value of dropdown.source" [value]="value.value">{{ value.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-12 row pr-0">
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Date/Time:</label>
                            </div>
                            <div class="col-md-5 kt-form__control">
                                <div class="input-group date">
                                    <div class="input-group-prepend">
                                        <select formControlName="date_type" class="form-control">
                                            <option [value]="item.key" *ngFor="let item of dateTimeFilterType">{{ item.label }}</option>
                                        </select>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Search"
                                        (change)="onDateRange($event)" formControlName="defaultDate"
                                        [timePicker]="true" [timePickerSeconds]="true"
                                        [alwaysShowCalendars]="true" [ranges]="ranges"
                                        [showCustomRangeLabel]="true" [locale]="dateTimePickerLocale"
                                        [timePicker24Hour]="true" [showDropdowns]="true" (click)="updateDateRange()"
                                    ngxDaterangepickerMd/>
                                    <span class="input-group-append">
                                        <span class="input-group-text pointer-calendar" (click)="onClearDate()">X</span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-1 kt-form__label col-form-label">
                                <label>Status:</label>
                            </div>
                            <div class="col-md-5 kt-form__control">
                                <div class="d-flex flex-wrap status-filter-pt">        
                                    <div class="custom-control custom-checkbox mr-3" *ngFor="let item of dropdown.statuses ; let i = index">
                                        <input type="checkbox" [checked]="item.checked" (change)="onSearchStatus($event, status[item.name], i)" class="custom-control-input" [id]="item.name">
                                        <label class="custom-control-label text-nowrap" [for]="item.name">{{ item.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="kt-section col-12 row d-flex justify-content-between mb-3 mt-3">
            <div class="dropdown dropdown-inline">
                <kt-search-button [loading]="searchBtnLoading" [disabledButton]="loading" (search)="onSubmit()"></kt-search-button>
                <kt-clear-button [loading]="clearBtnLoading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
            </div>
            <div class="dropdown dropdown-inline">
                <button *ngIf="canEditSetting" class="btn btn-setting btn-icon-sm" [disabled]="loading || settingBtnLoading" (click)="onOpenSettingDialog()"><i class="fas fa-cog"></i>Blast Setting</button>
            </div>
        </div>
        <div class="kt-section">
            <div class="kt-section__content">
                <div class="table-responsive">
                    <table class="table table-bordered table-hover table-striped table-sortable">
                        <thead>
                            <tr>
                                <th class="text-center sort-enabled" (click)="onSortColumn('campaign_code')" [ngClass]="sortingConfig.campaign_code" [class.sort-selected]="sortingSelection.sort_by === 'campaign_code'">Campaign Code</th>
                                <th class="text-center sort-enabled" (click)="onSortColumn('username')" [ngClass]="sortingConfig.username" [class.sort-selected]="sortingSelection.sort_by === 'username'">Username</th>
                                <th class="text-center sort-enabled" (click)="onSortColumn('mobile')" [ngClass]="sortingConfig.mobile" [class.sort-selected]="sortingSelection.sort_by === 'mobile'">Phone Number</th>
                                <th class="text-center">Source</th>
                                <th class="text-center sort-enabled" (click)="onSortColumn('status')" [ngClass]="sortingConfig.status" [class.sort-selected]="sortingSelection.sort_by === 'status'">Status</th>
                                <th class="text-center sort-enabled" (click)="onSortColumn('created_at')" [ngClass]="sortingConfig.created_at" [class.sort-selected]="sortingSelection.sort_by === 'created_at'">Created By</th>
                                <th class="text-center sort-enabled" (click)="onSortColumn('updated_at')" [ngClass]="sortingConfig.updated_at" [class.sort-selected]="sortingSelection.sort_by === 'updated_at'">Updated By</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="(whatsappCampaign$ | async) as rows">
                            <tr *ngFor="let row of rows">
                                <td>{{ row.campaign_code }}</td>
                                <td>
                                    <a *ngIf="canViewMemberDialog" [ngClass]="row.dummy == 1 ? 'text-dummy-clickable' : 'text-primary'" class="font-weight-bold" (click)="onOpenDialog('member-information', row.member_account_id)">
                                        {{ row.username }}
                                    </a>
                                    <span [ngClass]="row.dummy == 1 ? 'text-dummy-unclickable' : 'text-primary'" *ngIf="!canViewMemberDialog">{{ row.username }}</span>
                                </td>
                                <td>{{ row.mobile }}</td>
                                <td class="text-center">{{ row.source }}</td>
                                <td class="text-center">
                                    <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--wide" [ngClass]="'kt-badge--' + row.status"> {{ row.status_name }}</span>
                                </td>
                                <td>
                                    {{ 'System' }}<br/>
                                    <span placement="bottom" [ngbTooltip]="createdDateTime" container="body" class="text-ellipsis">{{ row.created_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                    <ng-template #createdDateTime>
                                        {{ row.created_at  | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                    </ng-template>
                                </td>
                                <td>
                                    {{ 'System' }}<br/>
                                    <span placement="bottom" [ngbTooltip]="updatedDateTime" container="body" class="text-ellipsis">{{ row.updated_at | timezoneDate: 'YYYY-MM-DD HH:mm' }}</span>
                                    <ng-template #updatedDateTime>
                                        {{ row.updated_at  | timezoneDate: 'YYYY-MM-DD HH:mm:ss' }}
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                        <tbody shared-table-handler [loading]="loading" [dataLength]="dataLength" class="text-gray-600 fw-bold"></tbody>
                    </table>
                </div>
                <div class="kt-pagination kt-pagination--brand mt-2" *ngIf="pagination !== undefined">
                    <ngb-pagination
                    [pageSize]="pageSize"
                    [(page)]="page"
                    [maxSize]="maxSize"
                    [directionLinks]="true"
                    [boundaryLinks]="true"
                    [rotate]="true"
                    [collectionSize]="pagination.total"
                    (pageChange)="onViewPageBy(page)">
                    </ngb-pagination>
                    <div class="kt-pagination__toolbar">
                        <select (change)="onPerPage($event)" [(ngModel)]="pageSize" class="form-control kt-font-brand page-size">
                            <option [value]="item" *ngFor="let item of dropdown.perPage">{{ item }}</option>
                        </select>
                        <span class="pagination__desc">
                        Showing {{pagination.from}} to {{pagination.to}} of {{ pagination.total | number : '1.0' }} records
                        </span>
                    </div>
                </div>
            </div>
        </div>
  </div>
</div>
<kt-swal-alert [message]="messages$ | async" ></kt-swal-alert>
